import jwtDecode from "jwt-decode";
import { useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { indianCurrencyFormater } from "../../../../helpers/functions/currencyFormater";
import AddEditAuctionUsers from "../../../../components/user/AddEditAuctionUsers";
import PaymentLinkModal from "../../../../components/user/PaymentLinkModal";
import CreateTAUserModal from "../../../trade-advance/onboarding/components/CreateTAUserModal";
import styles from "./TargetAchievementBanner.module.css";

/**
 * TargetAchievementBanner Component
 * A sticky performance tracker showing sales and payment progress
 */
function TargetAchievementBanner({
  payment_count_target_achieved = 0,
  sale_amount_target = 0,
  sale_amount_target_achieved = 0,
  payment_count_target = 0,
}) {
  const [showAddEditModal, setShowAddEditModal] = useState(false);
  const [showPaymentLinkModal, setShowPaymentLinkModal] = useState(false);
  const [paymentLink, setPaymentLink] = useState("");
  const [showTAOnboardingModal, setShowTAOnboardingModal] = useState(false);
  const currentUser = localStorage.getItem("refreshToken");
  const user = currentUser ? jwtDecode(currentUser) : null;
  // Calculate percentages
  const salePercentage = sale_amount_target
    ? ((sale_amount_target_achieved / sale_amount_target) * 100).toFixed(0)
    : 0;
  const paymentPercentage = payment_count_target
    ? ((payment_count_target_achieved / payment_count_target) * 100).toFixed(0)
    : 0;

  // Calculate gap and average deal size
  const gapToTarget = sale_amount_target - sale_amount_target_achieved;

  const location = useLocation();
  const isDashboardURL =
    location.pathname === "/dashboard/target/target-dashboard";
  return isDashboardURL ? null : (
    <>
      {showAddEditModal && (
        <AddEditAuctionUsers
          show={showAddEditModal}
          onHide={() => setShowAddEditModal(false)}
          data={{}}
          edit_form={false}
          set_fetch_data={() => {}}
          onUserCreatedLinkShow={(link) => {
            setPaymentLink(link);
            setShowPaymentLinkModal(true);
          }}
        />
      )}
      {showPaymentLinkModal && (
        <PaymentLinkModal
          show={showPaymentLinkModal}
          onHide={() => setShowPaymentLinkModal(false)}
          useFor="userAdd"
          link={paymentLink}
        />
      )}
      {showTAOnboardingModal && (
        <CreateTAUserModal
          setshow={setShowTAOnboardingModal}
          show={showTAOnboardingModal}
          onHide={() => setShowTAOnboardingModal(false)}
        />
      )}
      <div className={styles.banner}>
        <div className={styles.container}>
          {/* Left Section - Main Percentage */}
          <div className={styles.leftSection}>
            {/* <div className={styles.momentum}>
            <span className={styles.dot}></span>
            <span className={styles.momentumText}>TARGET MOMENTUM</span>
          </div> */}
            <div className={styles.mainPercentage}>
              <span className={styles.percentageNumber}>{salePercentage}%</span>
              <span className={styles.achievedText}>Achieved</span>
            </div>
          </div>

          {/* Middle Section - Progress Bars */}
          <div className={styles.middleSection}>
            {/* Revenue Goal */}
            <div className={styles.progressGroup}>
              <div className={styles.progressHeader}>
                <span className={styles.progressLabel}>Sale Amount Target</span>
                <span className={styles.progressValue}>
                  {indianCurrencyFormater(sale_amount_target_achieved, 0)} /{" "}
                  {indianCurrencyFormater(sale_amount_target, 0)}
                </span>
              </div>
              <div className={styles.progressTrack}>
                <div
                  className={styles.progressFill}
                  style={{ width: `${Math.min(salePercentage, 100)}%` }}
                ></div>
              </div>
            </div>

            {/* Unit Targets */}
            <div className={styles.progressGroup}>
              <div className={styles.progressHeader}>
                <span className={styles.progressLabel}>Payments Targets</span>
                <span className={styles.progressValue}>
                  {payment_count_target_achieved} / {payment_count_target}{" "}
                  Payments
                </span>
              </div>
              <div className={styles.progressTrack}>
                <div
                  className={styles.progressFill}
                  style={{ width: `${Math.min(paymentPercentage, 100)}%` }}
                ></div>
              </div>
            </div>
          </div>

          {/* Right Section - Stats */}
          <div className={styles.rightSection}>
            <div className={styles.statBox}>
              <div className={styles.statLabel}>GAP TO TARGET</div>
              <div className={styles.statValue}>
                {indianCurrencyFormater(gapToTarget, 0)}
              </div>
            </div>
            <div className={styles.buttonGroup}>
              <button
                className={styles.addUserBtn}
                onClick={() => setShowAddEditModal(true)}
              >
                <i className="bi bi-person-add"></i> Add User
              </button>
              {(user?.role === "Auction Representative" ||
                user?.role === "Business Analyst") && (
                <button
                  className={styles.addUserBtn}
                  onClick={() => setShowTAOnboardingModal(true)}
                >
                  <i className="bi bi-file-earmark-plus"></i> Start TA
                  Onboarding
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TargetAchievementBanner;
